import '../css/SmallButton.css'

const SmallButton = ({
    className,
    onClick,
    children,
}) => {
    return <div
        className={`SmallButton ${className}`}
        onClick={event => {
            event.stopPropagation()
            onClick(event)
        }}
    >
        {children}
    </div>
}

export default SmallButton